module.exports = __webpack_public_path__ + "img/new_report_icon.b44e87d2.svg";